__turbopack_context__.v({
  "link": "InactiveSubscriptionAlert-module__DwauMa__link",
  "modalButton": "InactiveSubscriptionAlert-module__DwauMa__modalButton",
  "modalButtons": "InactiveSubscriptionAlert-module__DwauMa__modalButtons",
  "modalContent": "InactiveSubscriptionAlert-module__DwauMa__modalContent",
  "modalTitle": "InactiveSubscriptionAlert-module__DwauMa__modalTitle",
  "subTitle": "InactiveSubscriptionAlert-module__DwauMa__subTitle",
});
